import Modal from "../../../global/Modal";
import DeleteReferralDialogue from "./DeleteReferralDialogue";

export default function DeleteModal({ open, onClose, onDelete }) {
  return (
    <Modal open={open} onClose={onClose} maxWidth="md">
      <DeleteReferralDialogue title="Delete Referral/s" onClickDelete={onDelete} />
    </Modal>
  );
}